import React from 'react';
import { ChevronRightRegularIcon, DoubleChatStrongIcon } from 'src/monet/icons';

export const DashboardHomeConversationsPanelOrigin = ({ onClick }: { onClick: () => void }) => (
  <div onClick={onClick} className='flex justify-between has-hover'>
    <div className='flex gap-2'>
      <DoubleChatStrongIcon />
      <span className='text-bedrock-p text-bedrock-black'>Conversations</span>
    </div>
    <ChevronRightRegularIcon />
  </div>
);
